// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"code-block_wrapper__Bo0gb","fallback":"code-block_fallback__owugi","copyBtn":"code-block_copyBtn__wUh_P","copyBtnSuccess":"code-block_copyBtnSuccess___OnEY"};